module.exports = __webpack_public_path__ + "img/7.cb3c8772.jpg";